module.exports = {"TXTWCL_Stake":{"id":"TXTWCL_Stake","defaultMessage":"賭け金","track":"Stake"}}